import { BooleanPropertyComponent } from '../components/BooleanPropertyComponent';
import { PropertySchema } from '../PropertySchema';

export const BooleanProperty = new PropertySchema('boolean', {
  component: BooleanPropertyComponent,
});
